<template>
  <van-button round type="info" class="contact-btn" @click="goToCreateWork">
    <template #icon>
      <em class="ico icon iconfont icon-service"></em>
    </template>
    {{ languages.smartOrderContactService }}
  </van-button>
</template>

<script>
import { mapState } from 'vuex';
import { clickButton } from '@plugins/biPoint/_configOfficialSupport';
export default {
  props: {
    source: {
      type: String,
      default: ''
    },
    customClick: {
      default: null
    }
  },
  computed: {
    ...mapState({
      languages: state => state.languages
    })
  },
  methods: {
    goToCreateWork() {
      if (this.customClick && typeof this.customClick === 'function') {
        this.customClick();
        return;
      }
      clickButton({
        btnName: 'clickGoCreateNormalOrder',
        locationKey: this.source || ''
      });
      this.$router.push({
        path: '/creatework',
        query: {
          source: this.source || ''
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.contact-btn {
  position: fixed;
  bottom: 38px;
  right: 10px;
  height: 50px;
  margin: 0 auto 18px;
  padding: 15px 13px;
  background-color: var(--block-bg-light-color);
  box-shadow: 0px 3px 10px 0px rgba(51, 51, 51, 0.1);
  border: none;
  color: var(--text-color);
  cursor: pointer;
  .ico {
    color: var(--main-color);
    font-size: 23px;
    margin-right: 3px;
  }
}
</style>
